<template>
<el-drawer :title="phoneDrawer.title" :visible.sync="phoneDrawer.visible" direction="rtl" custom-class="drawer-right-side">
  <div class="drawer-form">
    <el-form :model="phoneForm" :rules="phoneFormRules" ref="phoneForm" label-width="100px" label-position="left" class="demo-phoneForm">
      <el-form-item label="手机号" prop="mobile">
        <el-input v-model="phoneForm.mobile"></el-input>
      </el-form-item>
      <!-- <el-form-item label="坐席" prop="phone">
                <el-input v-model="phoneForm.phone"></el-input>
            </el-form-item> -->
      <el-form-item>
        <el-button type="primary" @click="savePhoneDrawer">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</el-drawer>
</template>

<script>
export default {
  data() {
    return {
      phoneDrawer: {
        title: '绑定手机号',
        visible: false
      },
      phoneForm: {
        id: '',
        mobile: ''
      },
      phoneFormRules: {
        mobile: [{
            required: true,
            message: '请输入电话',
            trigger: 'blur'
          },
          {
            pattern: /^1\d{10}$/,
            message: '手机号不合法',
            trigger: ['blur', 'change']
          }
        ]
      }
    };
  },
  methods: {
    // 显示抽屉
    showPhoneDrawer(row) {
      let that = this;
      that.phoneDrawer.visible = true;
      that.phoneForm.id = row.id;
      that.phoneForm.mobile = row.mobile;
      that.phoneForm.phone = row.telephone;
    },
    // 保存绑定手机号
    savePhoneDrawer() {
      let that = this;
      that.$refs['phoneForm'].validate((valid) => {
        if (valid) {
          let url = '/api/ucenter.user/bindSeat';
          let query = that.phoneForm;
          that.$post(url, query).then(function (res) {
            if (res.code == 200) {
              that.$emit('getTableData');
            } else {
              that.$message.error(res.msg);
            }
          });
        } else {
          that.$message.warning('请填写完整并检查您的填写信息');
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
@import url('@/assets/css/drawer.less');
.demo-phoneForm {
  padding: 0 32px;
}
</style>
